// File Name: Particles.jsx

import React, {
  useEffect,
  useRef,
} from "react";

export default function Particles({
  count = 32,
}) {

  const ref = useRef(null);

  useEffect(() => {

    const container = ref.current;

    if (!container) return;

    container.innerHTML = "";

    /* ===================================================== */
    /* MOBILE OPTIMIZATION */
    /* ===================================================== */

    const isMobile =
      window.innerWidth < 768;

    const finalCount = isMobile
      ? Math.floor(count * 0.55)
      : count;

    /* PREMIUM PURPLE PALETTE */

    const colors = [
      "#6D3B8C",
      "#8B5CF6",
      "#A855F7",
      "#C084FC",
      "#D8B4FE",
      "#E9D5FF",
      "#F0ABFC",
    ];

    for (let i = 0; i < finalCount; i++) {

      const particle =
        document.createElement("div");

      particle.className = "particle";

      /* ===================================================== */
      /* SIZE */
      /* ===================================================== */

      const size = isMobile
        ? 1.5 + Math.random() * 3.5
        : 2 + Math.random() * 6;

      particle.style.width = `${size}px`;

      particle.style.height = `${size}px`;

      /* ===================================================== */
      /* POSITION */
      /* ===================================================== */

      particle.style.left = `
        ${Math.random() * 100}%
      `;

      particle.style.top = `
        ${Math.random() * 100}%
      `;

      /* ===================================================== */
      /* OPACITY */
      /* ===================================================== */

      particle.style.opacity = `
        ${0.08 + Math.random() * 0.28}
      `;

      /* ===================================================== */
      /* ANIMATION */
      /* ===================================================== */

      particle.style.animation = `
        floatParticle
        ${10 + Math.random() * 18}s
        ease-in-out
        infinite
      `;

      particle.style.animationDelay = `
        ${Math.random() * 8}s
      `;

      /* ===================================================== */
      /* COLOR */
      /* ===================================================== */

      const color =
        colors[
          Math.floor(
            Math.random() * colors.length
          )
        ];

      particle.style.background = color;

      /* ===================================================== */
      /* PREMIUM GLOW */
      /* ===================================================== */

      particle.style.boxShadow = isMobile
        ? `
          0 0 8px ${color},
          0 0 18px ${color}55
        `
        : `
          0 0 12px ${color},
          0 0 28px ${color}66,
          0 0 48px ${color}33
        `;

      /* ===================================================== */
      /* GLASS EFFECT */
      /* ===================================================== */

      particle.style.backdropFilter =
        "blur(2px)";

      /* ===================================================== */
      /* SOFT ROUNDING */
      /* ===================================================== */

      particle.style.borderRadius =
        "999px";

      /* ===================================================== */
      /* BLEND */
      /* ===================================================== */

      particle.style.mixBlendMode =
        "screen";

      /* ===================================================== */
      /* PERFORMANCE */
      /* ===================================================== */

      particle.style.willChange =
        "transform, opacity";

      particle.style.transform =
        "translate3d(0,0,0)";

      container.appendChild(particle);

    }

  }, [count]);

  return (
    <>
      {/* ===================================================== */}
      {/* PARTICLE KEYFRAMES */}
      {/* ===================================================== */}

      <style>
        {`
          @keyframes floatParticle {

            0% {
              transform:
                translate3d(0, 0, 0)
                scale(1);

              opacity: 0.15;
            }

            25% {
              transform:
                translate3d(12px, -18px, 0)
                scale(1.08);

              opacity: 0.32;
            }

            50% {
              transform:
                translate3d(-10px, -38px, 0)
                scale(0.95);

              opacity: 0.18;
            }

            75% {
              transform:
                translate3d(14px, -20px, 0)
                scale(1.04);

              opacity: 0.28;
            }

            100% {
              transform:
                translate3d(0, 0, 0)
                scale(1);

              opacity: 0.15;
            }
          }

          /* ================================================= */
          /* MOBILE OPTIMIZATION */
          /* ================================================= */

          @media (max-width: 768px) {

            .particle {
              filter: blur(0.2px);
            }

          }

          /* ================================================= */
          /* REDUCE MOTION */
          /* ================================================= */

          @media (prefers-reduced-motion: reduce) {

            .particle {
              animation: none !important;
            }

          }
        `}
      </style>

      <div

        ref={ref}

        className="
          absolute inset-0

          pointer-events-none

          overflow-hidden
        "

        aria-hidden="true"
      />
    </>
  );
}